import type * as LDClient from 'launchdarkly-js-client-sdk';
import type { AutodeskContext, AutodeskUserProfile } from '../../types/forge';

export type InitPhase =
	| 'config'
	| 'auth'
	| 'identity'
	| 'flags'
	| 'data'
	| 'ready'
	| 'error';

export interface FlagsContext extends LDClient.LDUser {
	key: string;
	email: string;
}

export interface RunFlagsDeps {
	clientSideID?: string;
	liveUpdates?: boolean;
	context: FlagsContext;
	/** Called on every LD `change` event when liveUpdates is on. */
	onChange?: (flags: LDClient.LDFlagSet) => void;
	/** Injectable for tests; defaults to the real SDK initializer. */
	initialize?: typeof LDClient.initialize;
}

export interface RunFlagsResult {
	flags: LDClient.LDFlagSet;
	client: LDClient.LDClient | null;
}

export interface RunIdentityDeps {
	fetchUserProfile: () => Promise<AutodeskUserProfile>;
	/** Resolves null on landing pages (no autodesk context fetched). */
	fetchAutodeskContext: () => Promise<AutodeskContext | null>;
}

export interface RunIdentityResult {
	userProfile: AutodeskUserProfile;
	autodeskUserContext: AutodeskContext | null;
}
